import gql from 'graphql-tag'
import { resourceUnavailabilityFragment, resourceUnavailabilityTypeFragment } from '@/graphql/resourceUnavailability/resourceUnavailabilityFragments'

// export const UPSERTRESOURCEUNAVAILABILITY = gql`
//     mutation upsertAbsence(
//         $id: ID
//         $name: String!
//         $description: String
//         $typeID: ID
//         $disconnectType: Boolean
//         $tracked: Boolean
//         $applyTo: ApplyToModels
//     ){
//         upsertResourceUnavailability(
//             input: {
//                 id: $id
//                 name: $name
//                 description: $description
//                 type: {
//                     connect: $typeID
//                     disconnect: $disconnectType
//                 }
//                 tracked: $tracked
//                 applyTo: $applyTo
//             }
//         ){
//             ...resourceUnavailabilityFragment
//             type {
//                 ...resourceUnavailabilityTypeFragment
//             }
//         }
//     }
//     ${resourceUnavailabilityFragment}
//     ${resourceUnavailabilityTypeFragment}
// `
export const UPSERTRESOURCEUNAVAILABILITYTYPE = gql`
    mutation upsertResourceUnavailabilityType(
        $id: ID
        $name: String!
        $color: String
    ){
        upsertResourceUnavailabilityType(
            id: $id
            name: $name
            color: $color
        ){
            ...resourceUnavailabilityTypeFragment
        }
    }
    ${resourceUnavailabilityTypeFragment}
`
export const RESTORERESOURCEUNAVAILABILITYTYPE = gql`
    mutation restoreResourceUnavailabilityType(
        $id: ID!
    ){
        restoreResourceUnavailabilityType(
            id: $id
        ){
            ...resourceUnavailabilityTypeFragment
        }
    }
    ${resourceUnavailabilityTypeFragment}
`

export const DELETERESOURCEUNAVAILABILITY = gql`
    mutation deleteResourceUnavailability(
        $id: ID!
    ){
        deleteResourceUnavailability(
            id: $id
        ){
            ...resourceUnavailabilityFragment
        }
    }
    ${resourceUnavailabilityFragment}
`
export const DELETERESOURCEUNAVAILABILITYTYPE = gql`
    mutation deleteResourceUnavailabilityType(
        $id: ID!
    ){
        deleteResourceUnavailabilityType(
            id: $id
        ){
            ...resourceUnavailabilityTypeFragment
        }
    }
    ${resourceUnavailabilityTypeFragment}
`